import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'sd-page-not-found',
  templateUrl: './page-not-found.component.html',
})
export class PageNotFoundComponent {}
